import React from 'react'
import { Button, Text, View } from './Themed'
import { useColors } from '../constants/useColors'
import type { PublicPlayerProps } from '../types'
import { Image } from 'react-native'

type PlayerLozengeProps = {
    player: PublicPlayerProps,
    is_active?:boolean,
    hide_name?:boolean,
    onSelect: (player:PublicPlayerProps) => void
}
export const PlayerLozenge = ({ player, hide_name, is_active, onSelect }:PlayerLozengeProps) => {
    const Colors = useColors();
    
    const handleSelect = () => {
        if(!onSelect){ return }
        onSelect(player)
    }
    
    return (
        <Button float style={{ flexGrow:!hide_name ?1 : undefined,flexDirection:'row', alignItems:'center', margin:4, borderColor:is_active?Colors.text.success:Colors.borders.light, borderWidth:1, padding:2, borderRadius:100 }} onPress={() => handleSelect()}>
            <Image
                source={{ uri: player.profile_pic && player.profile_pic != '' ? player.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                style={{ height:36, width:36, borderRadius:100 }}
                resizeMode='cover'
            />
            {!hide_name ?
            <View transparent style={{ flexGrow:1, padding:10 }}>
                <Text theme='h2' color={is_active ? Colors.text.success: undefined}>@{player.username}</Text>
            </View>
            :<></>}
        </Button>
    )
}

export default PlayerLozenge